import _ from 'lodash'
import Vue from 'vue'

// The product-level prices both ways, beside the switch-following lowestPrice (OC-3012).
const productPriceFields = ['lowestPrice', 'lowestPriceExVat', 'lowestPriceIncVat', 'lowestListPriceExVat', 'lowestListPriceIncVat']

// Vue.set, not _.set: the list's products arrive without the OC-3012 fields, and a property added
// plainly is not reactive, so a card computed before the prices came kept them at 0 - a signed-in
// customer saw "Listpris 0,00 kr" under every product with variants.
function setProductPrices(product, prices) {
  _.forEach(productPriceFields, field => Vue.set(product, field, prices[field]))
}

function populatePricesFromBackend(productList, products) {
  _.forEach(productList, (productData, key) => {
    var prices = productData
    var currentKey = key
    _.forEach(products, (product) => {
      if(product.id === currentKey) {
        setProductPrices(product, prices)
        _.forEach(product.items, (item) => {
          var price = _.filter(prices.items, priceItem => priceItem.itemId === item.id)[0]
          if(price !== null && price !== undefined && price.itemId === item.id) {
            Vue.set(item, 'customerPrice', price)
          }
        })
      }
      if (product.replacementProducts && product.replacementProducts.length > 0) {
        _.forEach(product.replacementProducts, (replacementProduct) => {
          if(replacementProduct.id === currentKey) {
            setProductPrices(replacementProduct, prices)
            _.forEach(replacementProduct.items, (item) => {
              var price = _.filter(prices.items, priceItem => priceItem.itemId === item.id)[0]
              if(price !== null && price !== undefined && price.itemId === item.id) {
                Vue.set(item, 'customerPrice', price)
              }
            })
          }
        })
      }
    })
  })
}

export default { populatePricesFromBackend }
